import { supabase } from '../supabaseClient';

export const bridgesService = {
  async listAll() {
    const { data, error } = await supabase
      .from('bridges_with_status')
      .select('*')
      .order('last_heartbeat', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  async listForOrg(orgId) {
    const { data, error } = await supabase
      .from('bridges_with_status')
      .select('*')
      .eq('org_id', orgId)
      .order('last_heartbeat', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  async issueCommand(bridgeId, command, payload = {}, issuedBy = null) {
    const { data, error } = await supabase
      .from('bridge_commands')
      .insert({
        bridge_id: bridgeId,
        command,
        payload,
        issued_by: issuedBy,
        status: 'pending',
      })
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async listCommands(bridgeId, limit = 20) {
    const { data, error } = await supabase
      .from('bridge_commands')
      .select('*')
      .eq('bridge_id', bridgeId)
      .order('issued_at', { ascending: false })
      .limit(limit);
    if (error) throw error;
    return data || [];
  },

  async remove(bridgeId) {
    const { error } = await supabase.from('bridges').delete().eq('id', bridgeId);
    if (error) throw error;
  },
};

export const BRIDGE_STATUS_COLORS = {
  online:  '#00e5a0',
  stale:   '#f5a623',
  offline: '#e05757',
};
